var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 217,
    viewBox: "0 0 220 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189 30L219 60V0L189 30Z",
    fill: "#E0BC5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189 30L159 0V60L189 30Z",
    fill: "#CEB167"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 187L30 217H90L60 187Z",
    fill: "#EBD498"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 217L59.9999 187L-0.00012207 187L29.9999 217Z",
    fill: "#CBB786"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.908 33.0001L159 63.0922L219 62.9078L188.908 33.0001Z",
    fill: "#7A693D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204 111L159 66V156L204 111Z",
    fill: "#C7B994"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94 128.5L157 191V66L94 128.5Z",
    fill: "#9E906A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.092 92.9999L219 62.9078L159 63.0922L189.092 92.9999Z",
    fill: "#9E906A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 217V129L181 217H92.5Z",
    fill: "#D5C497"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatFull);
export default __webpack_public_path__ + "static/media/catFull.accfb36d.svg";
export { ForwardRef as ReactComponent };